module.exports = __webpack_public_path__ + "img/Identification-and-authentication-2.11a43840.png";